import _ from 'underscore';

angular.module('vastdesk').controller('DemandTagServerSideTableController', ['$scope', function ($scope) {
  $scope.demandTagBulkActionDisabledConditions = {
    onlyProgrammaticGuaranteedSelected: false,
  };

  const serverSideTable = $('#demand_tags_table');
  let allProgrammaticGuaranteedTagIds = [];

  serverSideTable.on('xhr.dt', function(e, settings, json, xhr) {
    if (json && json.custom_data && json.custom_data.programmatic_guaranteed_tag_ids) {
      allProgrammaticGuaranteedTagIds = json.custom_data.programmatic_guaranteed_tag_ids;
    }
  });

  $scope.$watchCollection('selectedDemandTagBulkActionIds', function (new_val, old_val) {
    if (!Array.isArray(new_val) || !Array.isArray(allProgrammaticGuaranteedTagIds)) {
      return;
    }

    $scope.demandTagBulkActionDisabledConditions.onlyProgrammaticGuaranteedSelected = _.difference(new_val, allProgrammaticGuaranteedTagIds).length === 0;
  });
}]);
